<template>
    <div class="site-wrapper">
        <div class="site-wrapper-inner">
            <div class="cover-container">
                <header class="masthead clearfix">
                </header>
                
                <main role="main" class="inner cover">
                <h1 class="cover-heading"><img src="assets/img/logo-white.svg" width="200" height="60" class="d-inline-block align-top" alt=""></h1>
                </br>   
                
                <section v-if="currentUser">
                    <div v-if="currentUserUsername">
                        <p class="lead">Welcome {{currentUser.displayName}}</p>
                        <button style="margin-bottom: 1em;" class="btn btn-lg btn-secondary" @click="goToCourseSelection">Continue</button>
                        <d-Logout></d-Logout>
                        
                        <section v-if="checkUser">
                        <a @click="goToAdmin">admin view</a>
                        </section> 
                    </div>
                    <div v-else>
                        <d-RegisterUsername></d-RegisterUsername>
                        <d-Logout></d-Logout>
                    </div>
                    
                </section>
                
                <section v-else>
                    <div v-if="loginOrRegister">
                        <div v-if="register">
                            <d-Register></d-Register>
                            <a @click="backClick">back</a>
                        </div>
                        <div v-if="login">
                            <d-Login></d-Login>
                            <a @click="backClick">back</a>
                        </div>
                    </div>
                    <div v-else>
                        <p class="lead">This is a prototype for the dacade learning communities. Start learning about blockchain in a new, more effective way. Study from curated materials, apply your knowledge, receive personal feedback and learn from the work of your peers.</p>
                        </br>
                        <button type="button" class="btn btn-primary btn-lg" @click.prevent="registerClick" style="margin-bottom:1em">Register</button><br>
                        <span style="font-weight:300">or</span> <a @click="loginClick">Sign in</a>
                    </div>

                </section>



                </p>            
                </main> 
    
          <footer class="mastfoot">
            <div class="inner">
              <p>Get to know more about dacade on <a href="http://dacade.org/">dacade.org</a> or <a href="https://t.me/dacade">telegram</a>.</p>
            </div>
          </footer>

        </div>

      </div>

    </div>


</template>

<script>

import { dbSubmissionsRef } from '../firebaseConfig'
import Login from './Login.vue'
import Register from './Register.vue'
import RegisterUsername from './RegisterUsername.vue'
import Logout from './Logout.vue'

export default {
    components: {
        dLogin: Login,
        dLogout: Logout,
        dRegister: Register,
        dRegisterUsername: RegisterUsername
    },
    data() {
        return {
            login:'',
            register:'',
            loginOrRegister:''
        }
    },
    
    methods: {
        goToCourseSelection() {
            this.$router.push({name: 'CourseSelectionLink'})
        },
        goToAdmin() {
            this.$router.push({name: 'AdminLink'})
        },
        loginClick() {
            this.login = 1
            this.loginOrRegister = 1
        },
        backClick() {
            this.login = ''
            this.register = ''
            this.loginOrRegister = ''
        },
        registerClick() {
            this.register = 1
            this.loginOrRegister = 1
        }
        
    },
    computed: {
        currentUser(){
          return this.$store.getters.currentUser
        },
        currentUserUsername(){
            if(this.currentUser.displayName){
                //console.log(this.currentUser.displayName)
                return this.currentUser.displayName
            }
        },
        checkUser(){
            if (this.currentUser){
                var data = this.$store.getters.checkUser(this.currentUser.uid);
                if (data) {
                    return data.id
                } else {
                return false
                }
          
            }
            else {
            return false
            }
        }

    }
}
</script>

<style scoped>
    @import '../assets/css/cover.css';
    /*.site-wrapper{*/
    /*    color:white!important;*/
    /*    font-weight:bolder;*/
    /*    background: url('../assets/img/bg-pattern-7.png'),linear-gradient(to left, #658ECB, #68B8BE) !important;*/
    /*}*/
    
.site-wrapper-inner {
    display: table-cell;
    vertical-align: middle;
}

.mastfoot {
    color: hsla(0,0%,100%,.5);
    position: fixed;
    bottom: 0;
}

@media (max-width: 575px) {
    .inner{
        padding:0.5rem 1rem;
    }
}
    
</style>


// WEBPACK FOOTER //
// src/components/LandingPage.vue